import { useProduct, useProductTextsGeneration } from '../model'
import { TextsForm, TextsGenerationsList } from './Texts'

export const TextsPage = () => {
    const texts = useProductTextsGeneration()
    const { isLoading, error } = useProduct()

    if (isLoading || error) {
        return null
    }

    return (
        <div className='relative w-full flex flex-col md:flex-row gap-[20px] mb-[89px]'>
            <div className='order-2 md:order-none flex flex-col gap-3 items-start w-full md:w-[60%]'>
                <TextsGenerationsList state={texts} />
            </div>
            <div className='order-1 md:order-none rounded-xl w-full md:w-[40%] flex flex-col gap-4'>
                <TextsForm texts={texts} />
            </div>
        </div>
    )
}
